import styled from "styled-components";

export const GlobalGalleryImageUploaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  z-index: 9999;
`;